export const identifiers = {
  artus: "artus",
  "bert-warehouse": "bertWarehouse",
  "bert-archive": "bertArchive",
};
